import { render, staticRenderFns } from "./modify-speech-template.vue?vue&type=template&id=4d30371b&scoped=true"
import script from "./modify-speech-template.vue?vue&type=script&lang=ts"
export * from "./modify-speech-template.vue?vue&type=script&lang=ts"
import style0 from "./modify-speech-template.vue?vue&type=style&index=0&id=4d30371b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d30371b",
  null
  
)

export default component.exports